import axios from "@/lib/axios";
import { Edition } from "@/types/edition";

export type GetEditionByIdRequestParams = {
  companyId: string;
  editionId: string;
};

export type GetEditionByIdResponse = Edition;

export const getEditionById = (params: GetEditionByIdRequestParams) =>
  axios
    .get<GetEditionByIdResponse>(
      `/v1/companies/${params.companyId}/editions/${params.editionId}`,
    )
    .then((res) => res.data);
